import LeadsService from "@/api/services/leads";
import { toCamelCase, isMpcpCategory } from "@estaly/ui";

const initialState = {
  unvalidLead: false,
  lead: null,
  logoUrl: "",
  brokerLogoUrl: "",
};

export default {
  namespaced: true,

  state: initialState,

  mutations: {
    setUnvalidLead(state, val) {
      state.unvalidLead = val;
    },

    setLead(state, lead) {
      state.lead = lead;
    },

    setLogoUrl(state, url) {
      state.logoUrl = url;
    },

    setBrokerLogoUrl(state, url) {
      state.brokerLogoUrl = url;
    },
  },

  getters: {
    unvalidLead: (state) => state.unvalidLead,
    lead: (state) => state.lead,
    logoUrl: (state) => state.logoUrl,
    brokerLogoUrl: (state) => state.brokerLogoUrl,
    isMpcpCategory: (state) => isMpcpCategory(state.lead?.category),
    productNotRequiredForLead: (state) => state.lead?.productless === true,
    isLeadConverted: (state) => state.lead?.status === "converted",
  },

  actions: {
    async fetch({ commit }, uniqueToken) {
      const response = await LeadsService.get(uniqueToken);

      if (!response?.success) {
        commit("setUnvalidLead", true);
        return response;
      }

      const data = toCamelCase(response.data);
      commit("setLogoUrl", data.store?.logoUrl);
      commit("setBrokerLogoUrl", data.store?.brokerLogoUrl);
      if (data.lead) commit("setLead", { ...data.lead, status: data.status });
      commit("setUnvalidLead", false);

      return response;
    },
  },
};
